<template>
    <client-page>
        <div id="contents">
            <v-container>
                <div class="title-wrap title-wrap--line">
                    <h2 class="font-42">작가게시판</h2>
                </div>

                <router-view name="board" code="bulletin" skin="gallery" :write-scope="['author']"></router-view>

            </v-container>
        </div>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";

export default {
    components: {
        ClientPage
    },
};
</script>
